import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa, 
         Pagination, PagingResponseModel, BasicApiResponseModel, ApiResponseModel } from '../shared';
import { OrgChartHierarchyNodeHdrContainerModel } from '../../../../../models/aggregates/hr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrgChartHierarchyNodeService extends BaseApiTemplateService<OrgChartHierarchyNodeHdrContainerModel> {

  // https://api.akaun.cloud/core2/tnt/dm/hr/org-charts/hierarchy-node-hdrs/backoffice-ep/query
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'org-charts/hierarchy-node-hdrs/backoffice-ep/query';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'org-charts/hierarchy-node-hdrs/backoffice-ep/query';
        this.httpClient = http;
    }

    public generateOrgChart(dtoObject: any, visa: ApiVisa, entities?: any,): Observable<any> {

      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path
      }
      if(entities){
        this.apiUrl = visa.api_domain_url + this.endpoint_path + `?entity_hdr_guids=${entities}`
      }
      return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl, dtoObject, this.getHttpHeader(visa));      
    }
}